import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { Link, useNavigate  } from "react-router-dom";
import { Search } from "react-feather";
 


function SearchCompo({ categories }) {
  const [searchInput, setSearchInput] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false); // Track loading state
  const [noResults, setNoResults] = useState(false); // Track no results

  const navigate = useNavigate();


  // Function to handle category selection
  const [selectedCategory, setSelectedCategory] = useState("1"); // Default category ID is 1

const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
};


  // Function to handle search input and fetch suggestions
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchInput(query);

    if (query.length > 2) {
      fetchSuggestions(query, selectedCategory);
    } else {
      setSuggestions([]);
      setNoResults(false);
    }
  };

  // Fetch product suggestions from the backend
  const fetchSuggestions = async (query, categoryId) => {
    setLoading(true);
    setNoResults(false);

    try {
      console.log(`🔍 Fetching suggestions for query: "${query}", categoryId: "${categoryId}"`);
      
      const response = await axios.get(`${baseurl}SearchProducts/${query}/${categoryId}`);
      
      console.log("📌 Full API Response:", response);
      console.log("📌 Response Data:", response.data);

      if (response.data.sellerListings?.length > 0) {
        setSuggestions(response.data.sellerListings);
        setNoResults(false);
      } else {
        setSuggestions([]);
        setNoResults(true); // No results found
      }
    } catch (error) {
      console.error("❌ Error fetching search suggestions:", error);
      setSuggestions([]);
      setNoResults(true); // Show no results on error
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    if (searchInput.trim()) {
      navigate(`/search-query/${encodeURIComponent(searchInput)}`);
    }
  };



  return (
    <>
  

      <div style={{ width: "100%", position: "relative", zIndex: '1', overflow: 'visible' }}>
        <form onSubmit={handleSubmit} className="d-flex justify-content-between" style={{ width: "100%" }}>
          <Link to="/search" className="w-100">
          <input
            className="form-control fz1 w-100"
            type="text"
            placeholder="Search..."
            value={searchInput}
            onChange={handleSearchChange}
          /></Link>
          
          <button className="btn btn-warning ms-2 fz2 border-0" type="submit">
              <Search/>
          </button>
        </form>

        {/* Search Suggestions Dropdown */}
        {searchInput.length > 2 && (
          <ul className="dropdown-menu show" style={{ width: "100%", position: "absolute", zIndex: 1000, maxHeight: "300px",overflow: "auto" }}>
            {loading ? (
              <li className="dropdown-item text-center">🔄 Loading...</li>
            ) : noResults ? (
              <li className="dropdown-item text-center">❌ No products found</li>
            ) : (
              suggestions.map((product) => (
                <li key={product.id}>
                  <a href={`/product/${product.slug}`} className="dropdown-item">
                    {product.title}
                  </a>
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </>
  );
}

export default SearchCompo;
